var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},_vm._l((_vm.steps),function(step,i){return _c('div',{key:i,staticClass:"stepGroup"},[_c('div',{staticClass:"circle"},[_vm._v(_vm._s(i + 1))]),_c('div',{staticClass:"hero"},[_vm._v(_vm._s(step.desc))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }